
import { useContext, useState } from "react"
import { Link } from "react-router-dom"
import { AccountMenu } from "./AccountMenu"
import { UserContext } from "../../../contexts/UserContext"
import { NotificationRender } from "../../global/NotificationRender"
import "./navbarActionItems.css"

export function NavbarActionItems() {
    const [searchBarDisplay, setSearchBarDisplay] = useState(false)

    const userDataContext = useContext(UserContext)
    const { user, notification } = userDataContext

    return (
        <>
            <div className="d-flex gap-3 justify-content-end align-items-center ms-auto action-items">

                <div className={
                    `searchbar off-lg-flx justify-content-end align-items-center ${searchBarDisplay ? "on" : "off"}`}>
                    <input
                        className={`search-field ${searchBarDisplay ? "on" : ""}`}
                        placeholder="What are you looking for?"
                    />
                    <div className={`search-icon ${searchBarDisplay ? "on" : ""}`}
                        onClick={() => setSearchBarDisplay(!searchBarDisplay)}>
                    </div>
                </div>

                <Link to={user ? "/wishlist" : "/login"} className="wishlist-item position-relative">
                    {
                        user && user.wishlist.length > 0 && (
                            <div className="position-absolute items-count">
                                {user && user.wishlist.length}
                            </div>
                        )
                    }
                    {
                        notification && notification.type.includes("WISHLIST") &&
                            <NotificationRender notification={notification} />
                    }
                </Link>
                
                <Link to={user ? "/cart" : "/login"} className="cart-nav-item position-relative">
                    {
                        user && user.cart.length > 0 && (
                            <div className="position-absolute items-count">
                                {user && user.cart.length}
                            </div>
                        )
                    }
                    {
                        notification && notification.type.includes("CART") &&
                            <NotificationRender notification={notification} />
                    }
                </Link>

                {
                    user && <AccountMenu />
                }
                
            </div>
        </>
    )
}